module.exports = __webpack_public_path__ + "hyperion-v2-static/img/grd_risk_mitigation.61dc503e.jpg";